import { inject, observer } from 'mobx-react';
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import globalTranslations from '../../../../i18n/globalTranslations';
import Order from '../../../../models/order/Order';
import { modelOf } from '../../../../prop-types';
import ConfigStore from '../../../../store/ConfigStore';

const messages = defineMessages({
  trackOrder: {
    id: 'checkout.trackOrder',
    defaultMessage:
      'You can track your order by clicking {link}, you can also get to the {merchantInfo} order tracking page from the confirmation email.',
  },
  shoppingCenterMerchantInfo: {
    id: 'checkout.shoppingCenterMerchantInfo',
    defaultMessage: "merchant's {merchant}",
  },
});

const OrderTrackingLink = ({ configStore, currentOrder }) => {
  if (!currentOrder.tracking_url) {
    return null;
  }

  const getTranslationValues = () => {
    const translationValues = {
      link: (
        <a href={currentOrder.tracking_url} target="_blank" rel="noopener">
          <FormattedMessage {...globalTranslations.hereSentence} />
        </a>
      ),
    };

    if (configStore.siteConfig.isShoppingCenter) {
      translationValues.merchantInfo = (
        <FormattedMessage
          {...messages.shoppingCenterMerchantInfo}
          values={{
            merchant: currentOrder.seller_name,
          }}
        />
      );
    } else {
      translationValues.merchantInfo = '';
    }

    return translationValues;
  };

  return (
    <div className="OrderTrackingLink">
      <FormattedMessage
        {...messages.trackOrder}
        values={getTranslationValues()}
      />
    </div>
  );
};

OrderTrackingLink.propTypes = {
  configStore: modelOf(ConfigStore).isRequired,
  currentOrder: modelOf(Order).isRequired,
};

export default inject('configStore')(observer(OrderTrackingLink));

